module.exports = __webpack_public_path__ + "static/media/Ayala Malls-new-logo-mobile.ec158e65.png";